"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _dates = require("../shared/dates");

var _dateFormatter = require("../shared/dateFormatter");

var _propTypes2 = require("../shared/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Weekdays =
/*#__PURE__*/
function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, _getPrototypeOf(Weekdays).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          calendarType = _this$props.calendarType,
          locale = _this$props.locale;
      return nextProps.calendarType !== calendarType || nextProps.locale !== locale;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          calendarType = _this$props2.calendarType,
          formatShortWeekday = _this$props2.formatShortWeekday,
          locale = _this$props2.locale;
      var beginOfMonth = this.beginOfMonth,
          year = this.year,
          monthIndex = this.monthIndex;
      var weekdays = [];

      for (var weekday = 1; weekday <= 7; weekday += 1) {
        var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
        var abbr = (0, _dateFormatter.formatWeekday)(locale, weekdayDate);
        weekdays.push(_react.default.createElement("div", {
          className: "react-calendar__month-view__weekdays__weekday",
          key: weekday,
          style: {
            flexGrow: 1
          }
        }, _react.default.createElement("abbr", {
          title: abbr,
          "aria-label": abbr
        }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
      }

      return _react.default.createElement(_Flex.default, {
        className: "react-calendar__month-view__weekdays",
        count: 7
      }, weekdays);
    }
  }, {
    key: "beginOfMonth",
    get: function get() {
      var activeStartDate = this.props.activeStartDate;
      return (0, _dates.getBeginOfMonth)(activeStartDate);
    }
  }, {
    key: "year",
    get: function get() {
      var beginOfMonth = this.beginOfMonth;
      return (0, _dates.getYear)(beginOfMonth);
    }
  }, {
    key: "monthIndex",
    get: function get() {
      var beginOfMonth = this.beginOfMonth;
      return (0, _dates.getMonthIndex)(beginOfMonth);
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;
Weekdays.defaultProps = {
  formatShortWeekday: _dateFormatter.formatShortWeekday
};
Weekdays.propTypes = {
  calendarType: _propTypes2.isCalendarType.isRequired,
  formatShortWeekday: _propTypes.default.func,
  locale: _propTypes.default.string,
  activeStartDate: _propTypes.default.instanceOf(Date).isRequired
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-calendar/dist/MonthView/Weekdays.js
 ** module id = 1325
 ** module chunks = 0
 **/